module.exports = __webpack_public_path__ + "static/img/3.2842280.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/3.png
// module id = lHXV
// module chunks = 0